import React, { useState, useEffect, useRef } from 'react'

export default function HoldButton({
	onDone,
	children,
	className,
	style,
} : {
	onDone: () => void,
	children: React.ReactNode,
	className?: string,
	style?: React.CSSProperties,
}) {
	const [holding, setHolding] = useState<boolean>(false)
	const timer = useRef<number | null>(null)

	const startHold = (e: React.PointerEvent) => {
		e.preventDefault()
		setHolding(true)
		timer.current = window.setTimeout(() => {
			onDone()
			setHolding(false)
		}, 1000)
	}

	const endHold = (e: React.PointerEvent) => {
		e.preventDefault()
		setHolding(false)
		if (timer.current) {
			clearTimeout(timer.current)
		}
	}

	return (
		<button
			style={style}
			className={
				(className ? className : '') +
				' hold-button' +
				(holding ? ' holding' : '')
			}
			onPointerDown={startHold}
			onPointerUp={endHold}
		>
			{children}
		</button>
	)
}